import React from 'react';

import {WidthItem} from 'src/components/width-item';

import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';


import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    data: UserShortInfo,
};

export const UserSuggestItem: React.FC<Props> = ({data}) => (
    <Group>
        <AvatarWrapped
            src={data.avatar}
            alt={data.userId.toString()}
            placeholder={Icons.USER}
            size={Size.SMALL}
            name={[data.firstName, data.lastName].join(' ')}
        />
        <WidthItem width={300}>
            <EllipsisTextHint title={[data.firstName, data.lastName].join(' ')}>
                {[data.firstName, data.lastName].join(' ')}
            </EllipsisTextHint>
        </WidthItem>
        <WidthItem width={300}>
            {!!data.email && (
                <EllipsisTextHint title={data.email} bold={true}>
                    {data.email}
                </EllipsisTextHint>
            )}
        </WidthItem>
    </Group>
);
